export const USER_TABLE_HEADERS = [
  "ID",
  "Name",
  "Surname",
  "Email",
  "Active",
  "Activate",
  "Delete",
];
